<template>
    <!-- Un id que no corresponde a ninguna categoria servia la ficha con las
         claves de traduccion sin resolver a la vista (`productos.keys.<id>`) y
         se autocanonicalizaba, de modo que cualquier id inventado generaba una
         URL indexable. -->
    <error-404 v-if="notFound"></error-404>
    <div v-else>
        <intro :product="key"></intro>
        <section v-if="key === 'junta_culata' || key === 'tornillos' || key === 'retenes' || key === 'tubos_engrase' || key === 'tubos_egr' || key === 'tubos_refrigeracion' || key === 'junta_turbo' || key === 'taques' || key === 'arbol_levas' || key === 'otros'" class="product-details section-links flex wrap">
            <template v-if="Object.keys($t(`productos.${key}.details.tips`)).length > 0">
                <article class="col-50 pad-sec">
                    <div class="container-text">
                        <h2 class="title title-26" v-if="$t(`productos.${key}.details.tips['tip-1']['title']`)" v-html="$t(`productos.${key}.details.tips['tip-1']['title']`)"></h2>
                        <p v-html="$t(`productos.${key}.details.tips['tip-1']['content']`)"></p>
                    </div>
                </article>
                <article class="col-50 pad-sec" v-if="$t(`productos.${key}.details.tips['tip-2']`) !== 'none'">
                    <div class="container-text">
                        <h2 class="title title-26" v-if="$t(`productos.${key}.details.tips['tip-2']['title']`)" v-html="$t(`productos.${key}.details.tips['tip-2']['title']`)"></h2>
                        <p v-html="$t(`productos.${key}.details.tips['tip-2']['content']`)"></p>
                    </div>
                </article>
            </template>
        </section>
        <section class="dropdown-product-details-container">
            <dropdown v-for="(dropdown, key) in $t(`productos.${key}.details.dropdowns`)" :key="key" :title="dropdown.title"
                :contentPanel="dropdown.content"></dropdown>
            <div class="sec-center">
                <a class="btn btn-dark -yellow-full" target="_blank"
                    :href="'mailto:'+$t(`contacto.email`)">
                    {{ $t(`productos.${key}.details.btn_more_info.text`) }}
                </a>
            </div>
        </section>
        <videos :intro="false" id="videos"></videos>
    </div>
</template>

<script lang="js">
import Intro from '@/components/view-parts/intros/product';
import Dropdown from '@/components/view-parts/dropdown';
import Videos from '@/components/view-parts/actualidad-parts/videos';
import Error404 from '@/components/views/error-404';
import {
    NOT_FOUND_ROUTE,
    applyPrerenderStatus,
    applyRobots,
    clearCanonicalAndAlternates,
    setMetaContent,
} from '@/seo/head';

export default {
    name: 'product-details',
    components: {
        'intro': Intro,
        'dropdown': Dropdown,
        'videos': Videos,
        'error-404': Error404,
    },
    data() {
        return {
            key: this.resolveKey(this.$route.params.id),
            notFound: false
        }
    },
    created() {
        if(!this.$route.params.id){
            this.$router.push('productos');
        }
    },
    mounted() {
        this.applyMeta();
    },
    methods: {
        /**
         * Clave de la categoria a partir del id de la URL, o `null` si el id no
         * corresponde a ninguna: vue-i18n devuelve la propia clave cuando no hay
         * traduccion, y asi es como `productos.keys.<id>` acababa escrito en el
         * <title> y en el cuerpo de la pagina.
         */
        resolveKey(rawId) {
            if (!rawId) return null;
            const id = rawId.replace('ç', 'c');
            const path = `productos.keys.${id}`;
            const key = this.$t(path);
            return key && key !== path ? key : null;
        },
        /** Metadatos de la ficha, o los de la 404 si el id no existe. */
        applyMeta() {
            if (!this.key) {
                this.showNotFound();
                return;
            }

            this.notFound = false;
            document.title = this.$t(`enlaces.seo.${this.key}.title`);
            setMetaContent("[name='description']", 'meta', { name: 'description' }, this.$t(`enlaces.seo.${this.key}.description`));
            setMetaContent("[property='og:title']", 'meta', { property: 'og:title' }, this.$t(`enlaces.seo.${this.key}.title`));
            setMetaContent("[property='og:description']", 'meta', { property: 'og:description' }, this.$t(`enlaces.seo.${this.key}.description`));
            setMetaContent("[name='keywords']", 'meta', { name: 'keywords' }, this.$t(`enlaces.seo.${this.key}.keyword`));

            // `location.href` arrastra el dominio del entorno y los parametros
            // de la URL. Se usa la canonica, que ya calculo router.beforeEach.
            const canonical = document.head.querySelector("[rel='canonical']");
            if (canonical) {
                setMetaContent("[property='og:url']", 'meta', { property: 'og:url' }, canonical.href);
            }
        },
        /** La categoria no existe: se declara 404 y se retiran las senales. */
        showNotFound() {
            this.notFound = true;
            document.title = this.$t('error_404.nombre');
            applyRobots(NOT_FOUND_ROUTE);
            applyPrerenderStatus(NOT_FOUND_ROUTE);
            clearCanonicalAndAlternates();
            window.prerenderReady = true;
        }
    },
    watch: {
      "$route.params.id"(){
        this.key = this.resolveKey(this.$route.params.id);
        this.applyMeta();
      }
    },
}
</script>

<style>
.product-details.section-links .pad-sec {
    padding: 60px 0 !important;
    flex-grow: 1;
}

.product-details.section-links .container-text {
    max-width: none !important;
}

.product-details.section-links article:first-of-type {
    background: rgb(5, 66, 121) !important;
    color: white !important;
}

.product-details.section-links .container-text .title-26{
    margin-bottom: 20px !important;
}

#videos {
    background-color: #cdd9e5 !important;
    padding-top: 0 !important;
}

@media screen and (max-width:930px) {
    .product-details.section-links {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .product-details.section-links article {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/product-details.vue